import { Grid, useMediaQuery } from '@mui/material';
import React from 'react';
import { useGetReportQuery } from '../../../../../app/Slices/SevenDayApiSlice';
import GuestCompanies from './GuestCompanies';
import GuestDetailsReportList from './IndividualGuestCompanyUsers';

export default function GuestDetailsComponentPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const urlRef = window.location.href.split('/')[4];

    //GET REPORT
    const { data: getReport } = useGetReportQuery(`/reports/guest-details`);

    return (
        <Grid sx={{ marginTop: isMobile ? '30px' : '0px' }}>
            {urlRef === 'guestDetails' ? (
                <GuestCompanies data={getReport} />
            ) : (
                <GuestDetailsReportList />
            )}
        </Grid>
    );
}
